export default "/images/c305e8f4bab65600819ebaf3c506a925.avif";